import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  transitId: string;
  notificationId: string;
}

export const useMarkCustomsNotificationAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transitId, notificationId }: HookProps) => {
      const { data } = await request({
        path: `transits/${transitId}/customs-notifications/${notificationId}/read`,
        method: 'PATCH',
        authenticate: true,
      });

      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['transit'] });
      toast.success('Notification marked read.');
    },
    onError: (error) => {
      showErrorToast(error, `Error marking the notification as read!`);
    },
  });
};
